<template>
  <TemplateRegistro :titulo="titulo" :texto="texto" @intro="submit()">
    <label for="uname">
      <strong>E-mail</strong>
    </label>
    <span class="telefono">{{ emailCliente }}</span>

    <div v-if="false">
      <br />
      <input v-model="okCorreoVerde" type="checkbox" class="aceptacion" />
      Aplicar este e-mail a todas mis pólizas.
    </div>

    <button class="pure-button ripple" @click.prevent="submit">
      <strong>El e-mail es correcto</strong>
    </button>

    <button
      class="pure-button ripple"
      style="background-color: red"
      @click.prevent="cancel"
    >
      <strong>No es mi e-mail</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
      okCorreoVerde: true,
      titulo: "Validación e-mail",
      texto: "Por favor, confirma que éste es tu correo electrónico",
    };
  },

  computed: {
    emailCliente() {
      return this.$store.state.registroInfo.email;
    },
  },

  methods: {
    modificarPolizas: async function () {
      let polizasAplicar = [];

      let lstVeh = this.$store.state.portfolio.lstPolizasVeh;
      lstVeh.forEach((element) => {
        //polizasAplicar.set(element.idPoliza, this.okCorreoVerde);
        polizasAplicar.push(element.idPoliza);
      });

      let lstHogar = this.$store.state.portfolio.lstPolizasHogar;
      lstHogar.forEach((element) => {
        //polizasAplicar.set(element.idPoliza, this.okCorreoVerde);
        polizasAplicar.push(element.idPoliza);
      });

      let result = await this.$store.dispatch("actualizarEmail", {
        idCliente: this.$store.state.portfolio.idCliente,
        email: this.emailCliente,
        polizas: polizasAplicar,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      this.$store.dispatch("getPortfolio");
    },

    modificarCliente: async function () {
      let result = await this.$store.dispatch("actualizarEmail", {
        idCliente: this.$store.state.portfolio.idCliente,
        email: this.emailCliente,
        polizas: null,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      this.$store.dispatch("getPortfolio");
    },

    hayGdprPdte() {
      let cliente = this.$store.state.portfolio.cliente;
      let gdprEmpresas = cliente.gdprEmpresas;
      return gdprEmpresas == null;
    },

    submit: async function () {
      if (this.okCorreoVerde) {
        console.log("okCorreoVerde: " + this.okCorreoVerde);
        this.modificarPolizas();
      } else {
        console.log("okCorreoVerde: " + this.okCorreoVerde);
        // FIXME Cambiar modificarPolizas por modificarCliente cuando el servidor este preparado
        this.modificarPolizas();
      }

      if (this.hayGdprPdte()) {
        this.$router.push({ name: "gdprTacito" });
      } else this.$router.replace({ name: "inicio" });
    },

    cancel() {
      this.$router.replace({ name: "email" });
    },
  },
};
</script>

<style lang="scss" scoped>
.aceptacion {
  font-size: 0.85rem;
}
</style>
